import React from 'react';
import { Modale, ModaleContent, ModaleTitre } from "../../../Modale";
import { Fieldset, BoutonRadio } from "../../../Form";
import dark from "@gouvfr/dsfr/dist/artwork/dark.svg";
import light from "@gouvfr/dsfr/dist/artwork/light.svg";
import system from "@gouvfr/dsfr/dist/artwork/system.svg";
import useLocalStorage from '../Hooks/useLocalStorage';
var ModaleParametreAffichage = function (_a) {
    var closeCallback = _a.closeCallback, changerThemeCallback = _a.changerThemeCallback;
    var _b = useLocalStorage('scheme', 'system'), scheme = _b[0], setScheme = _b[1];
    var onChangeTheme = function (event) {
        setScheme(event.target.value);
        changerThemeCallback(event.target.value);
    };
    var themes = [
        {
            nom: 'light',
            label: 'Thème clair',
            texteAide: '',
            image: light
        },
        {
            nom: 'dark',
            label: 'Thème sombre',
            texteAide: '',
            image: dark
        },
        {
            nom: 'system',
            label: 'Système',
            texteAide: 'Utilise les paramètres système.',
            image: system
        }
    ];
    return (React.createElement(Modale, { id: "parametre-affichage-footer", closeCallback: closeCallback },
        React.createElement(ModaleTitre, { idModale: "parametre-affichage-footer" }, "Param\u00E8tres d'affichage"),
        React.createElement(ModaleContent, null,
            React.createElement(Fieldset, { id: "parametre-affichage-fieldset", legende: "Choisissez un th\u00E8me pour personnaliser l'apparence du site." }, themes.map(function (theme) { return (React.createElement(BoutonRadio, { key: theme.nom, value: theme.nom, checked: scheme === theme.nom, id: "fr-radios-theme-".concat(theme.nom), name: "fr-radios-theme", label: theme.label, texteAide: theme.texteAide, image: React.createElement("img", { src: theme.image }), onChange: onChangeTheme })); })))));
};
export default ModaleParametreAffichage;
